export default "__VITE_ASSET__226d0c43__"